module.exports = __webpack_public_path__ + "img/LogoTitled.088fc011.png";